import React, { useState, useEffect } from 'react';
import './ProgressiveLoader.css';

const ProgressiveLoader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Simulate progressive loading
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setIsComplete(true);
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 300);
          return 100;
        }
        // Accelerate loading
        const increment = prev < 50 ? 10 : prev < 80 ? 5 : 2;
        return Math.min(prev + increment, 100);
      });
    }, 100);

    return () => clearInterval(interval);
  }, [onComplete]);

  if (isComplete) return null;

  return (
    <div className="progressive-loader">
      <div className="loader-content">
        <div className="loader-logo">
          <div className="logo-circle"></div>
        </div>
        <div className="loader-text">Loading...</div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="progress-text">{progress}%</div>
      </div>
    </div>
  );
};

export default ProgressiveLoader;

